/*       */

import React, { PureComponent } from 'react';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { DateTimePicker } from '@mic3/platform-ui';
import { set } from 'app/utils/immutable/Immutable';

class DateTime extends PureComponent {

    state = {
        initDate: null,
        isOpen: false,
        key: new Date()
    }

    @bind
    @memoize()
    getDialogProps(DialogProps) {
        return set(DialogProps, 'style.zIndex', 3000);
    }

    render() {
        const { DialogProps, ...rest } = this.props;
        const newDialogProps = this.getDialogProps(DialogProps);
        return <DateTimePicker
            DialogProps={newDialogProps}
            {...rest}
            value={rest.value || this.state.initDate}
            key={this.state.key}
            open={this.state.isOpen}
            onOpen={() => {
                this.setState({
                    key: new Date(),
                    isOpen: true,
                    initDate: new Date(),
                })
            }}
            onClose={() => {
                this.setState({
                    isOpen: false,
                    initDate: null,
                })
            }}
        />;
    }
}

export default DateTime;
